export default __webpack_public_path__ + "static/media/Data Penduduk.f5585028.png";